module.exports = __webpack_public_path__ + "static/img/16.34287e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/16.png
// module id = f5dx
// module chunks = 0